import React, { useState } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  AreaChart, Area,
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis
} from 'recharts';

const SpecificCustomer = () => {
  // --- STATE FOR TABS --- //
  const [activeTab, setActiveTab] = useState('Overview');

  // --- MOCK DATA FOR CHARTS (Overview Tab) --- //
  const barData = [
    { month: 'Jan', won: 3, lost: 4, pending: 1 },
    { month: 'Feb', won: 4, lost: 7, pending: 1 },
    { month: 'Mar', won: 2, lost: 6, pending: 1 },
    { month: 'Apr', won: 6, lost: 8, pending: 1 },
    { month: 'May', won: 4, lost: 6, pending: 1 },
    { month: 'Jun', won: 5, lost: 8, pending: 1 },
    { month: 'Jul', won: 7, lost: 10, pending: 1 },
    { month: 'Aug', won: 4, lost: 8, pending: 1 },
    { month: 'Sep', won: 6, lost: 9, pending: 1 },
    { month: 'Oct', won: 8, lost: 11, pending: 1 },
  ];

  const areaData = [
    { month: 'Jan', value: 2.2 },
    { month: 'Feb', value: 3.1 },
    { month: 'Mar', value: 2.8 },
    { month: 'Apr', value: 4.2 },
    { month: 'May', value: 3.6 },
    { month: 'Jun', value: 4.5 },
    { month: 'Jul', value: 5.8 },
    { month: 'Aug', value: 4.1 },
    { month: 'Sep', value: 5.1 },
    { month: 'Oct', value: 6.8 },
  ];

  const radarData = [
    { subject: 'Win Rate', A: 90, fullMark: 100 },
    { subject: 'Activity', A: 65, fullMark: 100 },
    { subject: 'Bid Value', A: 85, fullMark: 100 },
    { subject: 'Compliance', A: 95, fullMark: 100 },
    { subject: 'Response Rate', A: 80, fullMark: 100 },
    { subject: 'Doc Quality', A: 70, fullMark: 100 },
  ];

  // --- MOCK DATA FOR TABLE (Tenders Tab) --- //
  const tableData = [
    { id: 1, month: 'January', bids: 67, won: 28, lost: 28, pending: 67, bidVol: '₹9.2 Cr', winRate: '41.8%', wPct: 41.8 },
    { id: 2, month: 'February', bids: 142, won: 52, lost: 52, pending: 142, bidVol: '₹8.4 Cr', winRate: '36.6%', wPct: 36.6 },
    { id: 3, month: 'March', bids: 112, won: 38, lost: 38, pending: 112, bidVol: '₹7.8 Cr', winRate: '33.9%', wPct: 33.9 },
    { id: 4, month: 'April', bids: 98, won: 31, lost: 31, pending: 98, bidVol: '₹6.2 Cr', winRate: '31.6%', wPct: 31.6 },
    { id: 5, month: 'May', bids: 76, won: 22, lost: 22, pending: 76, bidVol: '₹4.8 Cr', winRate: '28.9%', wPct: 28.9 },
    { id: 6, month: 'June', bids: 54, won: 14, lost: 14, pending: 54, bidVol: '₹3.1 Cr', winRate: '23.9%', wPct: 23.9 },
    { id: 7, month: 'July', bids: 89, won: 21, lost: 21, pending: 89, bidVol: '₹5.7 Cr', winRate: '23.6%', wPct: 23.6 },
    { id: 8, month: 'August', bids: 43, won: 8, lost: 8, pending: 43, bidVol: '₹2.4 Cr', winRate: '18.6%', wPct: 18.6 },
  ];

  // --- MOCK DATA FOR BILLING (Billing Tab) --- //
  const invoiceData = [
    { id: 'INV-2026-006', period: '1 May 2026 - 1 May 2027', amount: '₹1,34,999', status: 'Paid', paidOn: '20 May 2026', method: 'Card' }
  ];

  // --- CHART TOOLTIP COMPONENT --- //
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-2 border shadow-sm rounded" style={{ fontSize: '0.8rem' }}>
          <p className="fw-bold mb-1">{label}</p>
          {payload.map((entry, index) => (
            <div key={index} style={{ color: entry.color }}>
              {entry.name}: {entry.value}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="container-fluid py-4" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
      
      {/* ADD THIS STYLE BLOCK TO REMOVE THE BLACK CLICK BOXES */}
      <style>{`
        .recharts-wrapper svg,
        .recharts-wrapper svg * {
          outline: none !important;
        }
      `}</style>

      {/* Top Header Section */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div className="d-flex align-items-center gap-3">
          <button className="btn btn-link text-muted p-0 text-decoration-none shadow-none fs-5">←</button>
          <div className="rounded-circle d-flex justify-content-center align-items-center text-white shadow-sm" style={{ width: '48px', height: '48px', backgroundColor: '#0f766e', fontSize: '1.2rem', fontWeight: '600' }}>
            SL
          </div>
          <div>
            <h4 className="mb-0 fw-bold" style={{ color: '#111827' }}>Semiconductors Ltd</h4>
            <div className="text-muted mt-1" style={{ fontSize: '0.8rem' }}>
              deepa@semicond.in • +91 9111222333 • Joined May 2024
            </div>
          </div>
        </div>
        <div className="d-flex gap-2">
          <span className="badge rounded-pill" style={{ backgroundColor: '#dcfce7', color: '#166534', padding: '0.4rem 0.8rem', fontWeight: '500' }}>Active</span>
          <span className="badge rounded-pill" style={{ backgroundColor: '#f3e8ff', color: '#7e22ce', padding: '0.4rem 0.8rem', fontWeight: '500' }}>Premium</span>
        </div>
      </div>

      {/* Summary Metrics Cards */}
      <div className="row g-3 mb-4">
        {[
          { title: 'TOTAL BIDS', value: '67', subtext: 'Since May 2024' },
          { title: 'TENDERS WON', value: '28', subtext: 'L1 awards', trend: '▲ Above avg', trendColor: '#16a34a' },
          { title: 'TENDERS LOST', value: '34', subtext: 'Incl. disqualified' },
          { title: 'WIN RATE', value: '41.8%', subtext: 'Avg: 29.4%', trend: '▲ Above avg', trendColor: '#16a34a' },
          { title: 'TOTAL BID VALUE', value: '₹9.2 Cr', subtext: 'Cumulative' },
          { title: 'REVENUE', value: '₹84,000', subtext: 'Renews: May 2025' },
        ].map((card, idx) => (
          <div className="col" key={idx} style={{ minWidth: '16%'}}>
            <div className="card h-100 bg-white p-3" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
              <h6 className="mb-2 text-uppercase" style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em' }}>{card.title}</h6>
              <h3 className="mb-2 fw-bold" style={{ color: '#111827', fontSize: '1.6rem' }}>{card.value}</h3>
              <p className="mb-1" style={{ fontSize: '0.75rem', color: '#6b7280' }}>{card.subtext}</p>
              {card.trend && (
                <p className="mb-0" style={{ fontSize: '0.7rem', color: card.trendColor, fontWeight: '600' }}>{card.trend}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Dynamic Tabs */}
      <div className="d-flex gap-4 mb-4" style={{ borderBottom: '1px solid #e5e7eb' }}>
        {['Overview', 'Tenders', 'Billing'].map((tab) => (
          <div
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              paddingBottom: '10px',
              borderBottom: activeTab === tab ? '2px solid #0f766e' : '2px solid transparent',
              color: activeTab === tab ? '#0f766e' : '#6b7280',
              fontWeight: activeTab === tab ? '600' : '500',
              fontSize: '0.9rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out'
            }}
          >
            {tab}
          </div>
        ))}
      </div>

      {/* CONDITIONAL RENDER: OVERVIEW TAB */}
      {activeTab === 'Overview' && (
        <div className="row g-4">
          {/* LEFT COLUMN */}
          <div className="col-xl-8 col-lg-7">
            {/* Bar Chart */}
            <div className="card bg-white p-4 mb-4" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
              <h6 className="fw-bold mb-0" style={{ color: '#111827' }}>Monthly Bidding Activity</h6>
              <p className="mb-4" style={{ color: '#6b7280', fontSize: '0.8rem' }}>Bids won, lost, pending per month</p>
              <div style={{ height: '220px', width: '100%' }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={barData} margin={{ top: 5, right: 0, left: -20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
                    <XAxis dataKey="month" axisLine={true} tickLine={false} tick={{ fontSize: 12, fill: '#6b7280' }} dy={10} />
                    <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6b7280' }} />
                    {/* ADDED cursor={false} TO REMOVE THE GREY HOVER BACKGROUND */}
                    <Tooltip cursor={false} content={<CustomTooltip />} />
                    <Legend iconType="square" wrapperStyle={{ fontSize: '0.8rem', paddingTop: '20px' }} />
                    <Bar dataKey="won" name="Won" stackId="a" fill="#16a34a" barSize={40} />
                    <Bar dataKey="lost" name="Lost" stackId="a" fill="#dc2626" />
                    <Bar dataKey="pending" name="Pending" stackId="a" fill="#d97706" radius={[4, 4, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Area Chart */}
            <div className="card bg-white p-4" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
              <h6 className="fw-bold mb-4" style={{ color: '#111827' }}>Bid Value Trend (₹ Cr)</h6>
              <div style={{ height: '120px', width: '100%' }}>
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart data={areaData} margin={{ top: 5, right: 0, left: -20, bottom: 0 }}>
                    <defs>
                      <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#0f766e" stopOpacity={0.15}/>
                        <stop offset="95%" stopColor="#0f766e" stopOpacity={0}/>
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
                    <XAxis dataKey="month" axisLine={true} tickLine={false} tick={{ fontSize: 12, fill: '#6b7280' }} dy={10} />
                    <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6b7280' }} />
                    <Tooltip content={<CustomTooltip />} />
                    <Area type="monotone" dataKey="value" stroke="#0f766e" strokeWidth={2} fillOpacity={1} fill="url(#colorValue)" />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="col-xl-4 col-lg-5">
            {/* Radar Chart */}
            <div className="card bg-white p-3 mb-3 d-flex flex-column" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)', height: '340px' }}>
              <h6 className="fw-bold mb-0" style={{ color: '#111827' }}>Performance Radar</h6>
              <div style={{ flexGrow: 1, width: '100%', minHeight: '120px' }} className="d-flex justify-content-center align-items-center mt-2">
                <ResponsiveContainer width="100%" height="100%">
                  <RadarChart cx="50%" cy="50%" outerRadius="75%" data={radarData}>
                    <PolarGrid stroke="#e5e7eb" />
                    <PolarAngleAxis dataKey="subject" tick={{ fill: '#6b7280', fontSize: 11 }} />
                    <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} axisLine={false} />
                    <Radar name="Performance" dataKey="A" stroke="#0f766e" fill="#0f766e" fillOpacity={0.25} />
                    <Tooltip content={<CustomTooltip />} />
                  </RadarChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Outcome Summary */}
            <div className="card bg-white p-3" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)', height: '170px' }}>
              <h6 className="fw-bold mb-3" style={{ color: '#111827' }}>Outcome Summary</h6>
              <div className="d-flex gap-3 mb-3">
                <div className="flex-fill rounded text-center p-2" style={{ backgroundColor: '#dcfce7' }}>
                  <div className="fw-bold fs-4" style={{ color: '#166534' }}>28</div>
                  <div style={{ fontSize: '0.75rem', color: '#166534', fontWeight: '500' }}>Won</div>
                </div>
                <div className="flex-fill rounded text-center p-2" style={{ backgroundColor: '#fee2e2' }}>
                  <div className="fw-bold fs-4" style={{ color: '#991b1b' }}>34</div>
                  <div style={{ fontSize: '0.75rem', color: '#991b1b', fontWeight: '500' }}>Lost</div>
                </div>
                <div className="flex-fill rounded text-center p-2" style={{ backgroundColor: '#fef3c7' }}>
                  <div className="fw-bold fs-4" style={{ color: '#92400e' }}>5</div>
                  <div style={{ fontSize: '0.75rem', color: '#92400e', fontWeight: '500' }}>Pending</div>
                </div>
              </div>
              <div className="w-100 d-flex" style={{ height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
                <div style={{ width: '41.8%', backgroundColor: '#16a34a' }}></div>
                <div style={{ width: '50.7%', backgroundColor: '#dc2626' }}></div>
                <div style={{ width: '7.5%', backgroundColor: '#d97706' }}></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CONDITIONAL RENDER: TENDERS TAB */}
      {activeTab === 'Tenders' && (
        <div className="card bg-white" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
          <div className="d-flex justify-content-between align-items-center p-3" style={{ borderBottom: '1px solid #f3f4f6' }}>
            <h6 className="fw-bold mb-0" style={{ color: '#111827' }}>Tender History - Semiconductor Ltd</h6>
            <span style={{ fontSize: '0.75rem', color: '#6b7280', cursor: 'pointer' }}>Click any row to view full profile & performance →</span>
          </div>

          <div className="table-responsive">
            <table className="table align-middle mb-0" style={{ fontSize: '0.8rem' }}>
              <thead>
                <tr style={{ color: '#6b7280', fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.05em', borderBottom: '1px solid #e5e7eb' }}>
                  <th className="py-3 px-4 border-bottom-0">MONTH</th>
                  <th className="text-center border-bottom-0">BIDS SUBMITTED</th>
                  <th className="text-center border-bottom-0">WON</th>
                  <th className="text-center border-bottom-0">LOST</th>
                  <th className="text-center border-bottom-0">PENDING</th>
                  <th className="text-center border-bottom-0">TOTAL BID VALUE</th>
                  <th className="border-bottom-0" style={{ width: '150px' }}>WIN RATE</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row) => (
                  <tr key={row.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td className="px-4 py-3" style={{ color: '#6b7280', fontWeight: '500' }}>{row.month}</td>
                    <td className="text-center" style={{ fontWeight: '700', color: '#111827' }}>{row.bids}</td>
                    <td className="text-center" style={{ fontWeight: '700', color: '#16a34a' }}>{row.won}</td>
                    <td className="text-center" style={{ fontWeight: '700', color: '#dc2626' }}>{row.lost}</td>
                    <td className="text-center" style={{ fontWeight: '700', color: '#111827' }}>{row.pending}</td>
                    <td className="text-center" style={{ color: '#6b7280' }}>{row.bidVol}</td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <div style={{ width: '40px', height: '6px', backgroundColor: '#e5e7eb', borderRadius: '4px', overflow: 'hidden' }}>
                          <div style={{ width: `${row.wPct}%`, height: '100%', backgroundColor: '#0f766e', borderRadius: '4px' }}></div>
                        </div>
                        <span style={{ fontWeight: '600', color: '#0f766e', fontSize: '0.75rem' }}>{row.winRate}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center p-3" style={{ borderTop: '1px solid #f3f4f6' }}>
            <span style={{ color: '#6b7280', fontSize: '0.8rem' }}>Showing 8 of 8 customers</span>
            <div className="d-flex gap-1">
              <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#ccfbf1', color: '#0f766e', border: '1px solid #5eead4', fontSize: '0.8rem', fontWeight: '500', width: '32px' }}>1</button>
              <button className="btn btn-sm bg-white shadow-none" style={{ border: '1px solid #e5e7eb', color: '#4b5563', fontSize: '0.8rem', width: '32px' }}>2</button>
              <button className="btn btn-sm bg-white shadow-none" style={{ border: '1px solid #e5e7eb', color: '#4b5563', fontSize: '0.8rem', width: '32px' }}>3</button>
            </div>
          </div>
        </div>
      )}

      {/* CONDITIONAL RENDER: BILLING TAB */}
      {activeTab === 'Billing' && (
        <>
          {/* Billing Summary Cards */}
          <div className="row g-3 mb-4">
            {[
              { title: 'CURRENT PLAN', value: 'PREMIUM', subtext: '₹27,000/mo' },
              { title: 'TOTAL PAID', value: '₹1,34,999', subtext: 'All Time' },
              { title: 'NEXT RENEWAL', value: 'JUNE 2027', subtext: 'Auto-renew on' },
              { title: 'PAYMENT STATUS', value: 'PAID', subtext: 'Current Cycle' },
            ].map((card, idx) => (
              <div className="col" key={idx} style={{ minWidth: '22%' }}>
                <div className="card h-100 bg-white p-4" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
                  <h6 className="mb-3 text-uppercase" style={{ fontSize: '0.7rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em' }}>{card.title}</h6>
                  <h3 className="mb-2 fw-bold" style={{ color: '#111827', fontSize: '1.75rem' }}>{card.value}</h3>
                  <p className="mb-0" style={{ fontSize: '0.8rem', color: '#6b7280' }}>{card.subtext}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Invoice History Table */}
          <div className="card bg-white" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
            <div className="p-3" style={{ borderBottom: '1px solid #f3f4f6' }}>
              <h6 className="fw-bold mb-0" style={{ color: '#111827', padding: '0.5rem 0.5rem' }}>Invoice History</h6>
            </div>

            <div className="table-responsive">
              <table className="table align-middle mb-0" style={{ fontSize: '0.85rem' }}>
                <thead>
                  <tr style={{ color: '#6b7280', fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.05em', borderBottom: '1px solid #e5e7eb', backgroundColor: '#f9fafb' }}>
                    <th className="py-3 px-4 border-bottom-0 text-center">INVOICE ID</th>
                    <th className="text-center border-bottom-0">PERIOD</th>
                    <th className="text-center border-bottom-0">AMOUNT</th>
                    <th className="text-center border-bottom-0">STATUS</th>
                    <th className="text-center border-bottom-0">PAID ON</th>
                    <th className="text-center border-bottom-0">METHOD</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceData.map((row, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      <td className="px-4 py-4 text-center" style={{ fontWeight: '700', color: '#111827' }}>{row.id}</td>
                      <td className="text-center" style={{ color: '#6b7280', fontWeight: '500' }}>{row.period}</td>
                      <td className="text-center" style={{ fontWeight: '700', color: '#111827' }}>{row.amount}</td>
                     <td className="text-center">
  <span
    className="badge rounded-pill"
    style={{
      backgroundColor: '#dcfce7',
      color: '#166534',
      padding: '0.17rem 0.75rem',
      fontWeight: '500',
      fontSize: '0.72rem',
      lineHeight: '1',
      display: 'inline-block'
    }}
  >
    {row.status}
  </span>
</td>
                      <td className="text-center" style={{ fontWeight: '700', color: '#111827' }}>{row.paidOn}</td>
                      <td className="text-center" style={{ color: '#6b7280', fontWeight: '500' }}>{row.method}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

    </div>
  );
};

export default SpecificCustomer;